// Reducer Types
interface State {
  page: number;
  list: any[];
  count: number;
   templateDetails: any | null; 
}

export const emailAndNotificationReducer = (
  state: State = {
    list: [],
    count: 0,
    page: 1,
    templateDetails:null
  },
  action: any
): State => {
  switch (action.type) {
    case "GET_TEMPLATES_DATA": {
      // ✅ payload.data IS ALREADY ARRAY
      const incomingList = Array.isArray(action.payload?.data)
        ? action.payload.data
        : [];
      return {
        ...state,
        list:
          action.payload.page === 1 || !action.payload.page
            ? incomingList
            : [...state.list, ...incomingList],
        count: action.payload?.count ?? 0,
        page: action.payload.page,
      };
    }

    case "UPDATE_TEMPLATES_DATA":
      return {
        ...state,
        list: state.list.map((elem: any) =>
          elem?._id === action.payload?._id ? action.payload : elem
        ),
      };

     case "UPDATE_TOGGLE_TEMPLATE_DATA":
  return {
    ...state,
    list: state.list.map((elem: any) =>
      elem?._id === action.payload?._id
        ? {
            ...elem,
            is_active: elem.is_active === 1 ? 0 : 1,
          }
        : elem
    ),
  };

    case "SET_TEMPLATE_DETAILS":
      return {
        ...state,
        templateDetails: action.payload || null,
      };

    default:
      return state;
  }
};
